<template>
  <div class="card-normal">
    <div v-if="carregando" class="carregando"><i class="el-icon-loading"></i></div>
    <div :class="carregando ? 'blur' : ''">
      <h2>Histórico mensal</h2>
      <div v-if="horas.length === 0" class="py-4">
        <span style="opacity: .5;">O colaborador não possui histórico de horas.</span>
      </div>
      <div v-else class="dia" v-for="(item, index) in horas" :key="index">
        <p class="data">{{item.mes.format('MMMM [de] YYYY')}}</p>
        <p class="hora" style="margin:0;">{{item.horas}}</p>
        <p class="horas-extras" :class="(item.minutos_extras >= 0) ? 'extra' : 'falta'">
          {{(item.minutos_extras >= 0) ? 'Horas extras' : 'Devendo'}}: {{ item.horas_extras }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { calculaHorasMesesColaborador } from '../../config/functions';

export default {
  name: 'HistoricoMensal',
  props: {
    horasSemana: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    carregando: true,
    horas: [],
    hoje: moment()
  }),
  mounted() {
    setTimeout(() => {
      calculaHorasMesesColaborador(this.hoje, this.$route.params.user, this.horasSemana).then(horas => {
        if (horas) this.horas = horas;
        this.carregando = false;
      });
    }, 300);
  }
};
</script>

<style lang="scss" scoped>
.carregando {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-items: center;
  text-align: center;

  i {
    margin: 0 auto;
    font-size: 30px;
  }
}
</style>
